var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.drag_element != null)?_c('div',{staticClass:"event",staticStyle:{"z-index":"99","transition":"0s all","display":"flex"},style:({
  width: _vm.drag_element.width + 'px',
  top: _vm.drag_element.top + 'px',
  left: _vm.drag_element.left + 'px',
  'background-color': _vm.drag_element.color,
})},[_c('div',{staticClass:"event_title"},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"10px"}},[_vm._v(_vm._s(_vm.drag_element.contact))]),_vm._v(" "+_vm._s(_vm.drag_element.name)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }